<template>
  <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(onChange)">
      <div
        class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
        style="margin-bottom:0px"
      >
        <h2 class="title text-primary black" style="margin-top:12px">{{$t('Change password')}}</h2>
      </div>

      <md-card-content>
        <validation-provider
          ref="formValidatorOldPassword"
          vid="oldPassword"
          rules="min:5"
          v-slot="v"
          mode="lazy"
        >
          <md-field class="md-form-group" :class="{'md-invalid md-error' : v.failed}">
            <md-icon>lock_outline</md-icon>
            <label class="required">{{ $t('Password') }}</label>
            <md-input v-model="model.oldPassword" type="password" />
          </md-field>
          <p class="md-error regular">
            <span v-for="error in v.errors" :key="error">{{error}}</span>
          </p>
        </validation-provider>
        <validation-provider
          ref="formValidatorNewPassword"
          vid="newPassword"
          rules="min:5"
          v-slot="v"
          mode="lazy"
        >
          <md-field class="md-form-group" :class="{'md-invalid md-error' : v.failed}">
            <md-icon>lock_outline</md-icon>
            <label class="required">{{ $t('New password') }}</label>
            <md-input v-model="model.newPassword" type="password" />
          </md-field>
          <p class="md-error regular">
            <span v-for="error in v.errors" :key="error">{{error}}</span>
          </p>
        </validation-provider>

        <validation-provider
          ref="formValidatorConfirmNewPassword"
          vid="confirmNewPassword"
          rules="min:5|confirmed:newPassword"
          v-slot="v"
          mode="lazy"
        >
          <md-field class="md-form-group" :class="{'md-invalid md-error' : v.failed}">
            <md-icon>lock_outline</md-icon>
            <label class="required">{{ $t('Confirm new password') }}</label>
            <md-input v-model="model.confirmNewPassword" type="password" />
          </md-field>
          <p class="md-error regular">
            <span v-for="error in v.errors" :key="error">{{error}}</span>
          </p>
        </validation-provider>
      </md-card-content>

      <md-card-actions>
        <md-button
          class="md-button md-round md-primary md-sm md-theme-default"
          type="submit"
        >{{ $t('Submit') }}</md-button>
      </md-card-actions>
    </form>
  </validation-observer>
</template>

<script>
import axios from "@/util/axios";
import { mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, confirmed, min } from "vee-validate/dist/rules";

extend("required", required);
extend("confirmed", confirmed);
extend("min", min);

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },

  computed: {
    ...mapGetters({ language: "language/current" })
  },

  data() {
    return {
      model: {
        oldPassword: '',
        newPassword: null,
        confirmNewPassword: null
      }
    };
  },
  methods: {
    async onChange() {
      let loader = this.$loading.show();

      try {
        let result = await axios.post("auth/changePassword", {
          ...this.model
        });
        this.$swal({
          icon: "success",
          title: this.$t("Done"),
          text: this.$t("Password has been changed")
        });
      } catch (exception) {
        
      } finally {
        loader.hide();
      }
    },
    onBackToLoginPage() {
      this.$router.push({ name: "login" });
    }
  },
  watch: {
    language() {
      if (this.$refs.formValidatorOldPassword.errors.length > 0) {
        this.$refs.formValidatorOldPassword.validate();
      }
      if (this.$refs.formValidatorNewPassword.errors.length > 0) {
        this.$refs.formValidatorNewPassword.validate();
      }
      if (this.$refs.formValidatorConfirmNewPassword.errors.length > 0) {
        this.$refs.formValidatorConfirmNewPassword.validate();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-fab,
.md-icon-button {
  z-index: 0 !important;
}
.md-icon {
  z-index: 0;
}
</style>
